<template>
  <v-snackbar
    right
    multi-line
    :color="color"
    :value="model.visible"
    :timeout="2000"
  >
    <b>
      <span>{{model.message}}</span>
    </b>
    <v-btn
      text
      @click="reset"
    >
      Chiudi
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'SnackNotification',
    data() {
      return {
        model: {
          error: null,
          visible: null,
          message: null
        }
      }
    },
    props: {
      snack: { type: Object },
    },
    computed: {
      color() {
        return this.model.error ? 'pink' : 'primary'
      }
    },
    methods: {
      reset() {
        this.model = {
          error: null,
          visible: null,
          message: null
        }
      }
    },
    watch: {
      snack: {
        handler(val) {
          this.model = val
        }
      },
      deep: true
    }
  }
</script>

<style>
</style>